import { render } from "./MultiSelect.vue?vue&type=template&id=1204a023"
import script from "./MultiSelect.vue?vue&type=script&lang=js"
export * from "./MultiSelect.vue?vue&type=script&lang=js"

import "./MultiSelect.vue?vue&type=style&index=0&id=1204a023&lang=scss"

import exportComponent from "/Users/pavel/FrontReportTechnomoscow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__